<template>
    <div class="row">
        <div v-if="role" class="col-12">
            <div class="d-flex flex-row align-items-center">
                <h1>{{ $t("edit") + ` ${role.name ? role.name : ''}` }}</h1>

                <button
                    type="button"
                    class="btn btn-primary ml-auto mr-2 px-3"
                    @click="updateRole"
                >
                    {{ $t('save') }}
                </button>

                <button
                    type="button"
                    class="btn btn-danger"
                    @click="openDeleteDialog"
                >
                    {{ $t('delete') }}
                </button>
            </div>

            <div v-if="updateMsg" class="alert alert-success">{{ updateMsg }}</div>
            <div v-if="validate && errors" class="text-danger mb-2">{{ $t('required-fields-missing') }}</div>

            <TextInput v-model="role.name" :label="$t('name')" :error="validate && !role.name" />

            <TextAreaAutosize v-model="role.description" :label="$t('description')" />

            <PrivilegesEdit :role="role" />
        </div>
    </div>
</template>

<script>
import PrivilegesEdit from 'src/components/Roles/PrivilegesEdit.vue'

export default {
    data() {
        return {
            role: undefined,
            errors: false,
            validate: false,
            updateMsg: '',
        }
    },
    mounted() {
        this.fetchRole()
    },
    watch: {
    	role: {
			handler(){
				this.$emit('dataChanged', true);
			},
			deep: true
    	}
    },
    methods: {
        async fetchRole() {
            this.$store.commit('showBlockingSpinner')

            try {
                const res = await this.$cfetch(`${this.$settings.APIBaseURL}/roles/get`, {
                    method: 'GET',
                    data: { id: this.$route.params.roleId },
                })

                if (res.status !== 'SUCCESS') {
                    this.$store.commit("openDialog", {
                        title: this.$t("something-went-wrong"),
                        content: this.$t('role-not-found'),
                        confirmCallBack: this.$router.push('/settings/users/roles')
                    })
                    return
                }

                this.role = res.role;
                this.$nextTick(() => {
    				this.$emit('dataChanged', false);
    			});
            }
            catch (err) {
                this.$log.error.call(this, err)
                this.$router.push('/settings/users/roles')
            }
            finally {
                this.$store.commit('hideBlockingSpinner')
            }
        },
        async updateRole() {
            this.validate = true
            this.errors = false

            if (!this.role.name) this.errors = true

            if (this.errors) return

            try {
                this.updateMsg = ''
                this.$store.commit('showBlockingSpinner')

                const res = await this.$cfetch(`${this.$settings.APIBaseURL}/roles/update`, {
                    method: 'POST',
                    data: {
                        ...this.role,
                        privileges: JSON.stringify(this.role.privileges),
                    }
                })

                if (res.status === 'SUCCESS') {
                    this.validate = false
                    this.updateMsg = this.$t('role-updated');
					this.$nextTick(() => {
						this.$emit('dataChanged', false);
					});
                    return
                }
                else this.$store.commit("openDialog", {
                    title: this.$t("something-went-wrong"),
                    content: this.$t('role-update-failed'),
                    confirmCallBack: function () {}
                })
            } catch (err) {
                this.$log.error.call(this, err)
            } finally {
                this.$store.commit('hideBlockingSpinner')
            }
        },
        async deleteRole() {
            try {
                const res = await this.$cfetch(`${this.$settings.APIBaseURL}/roles/delete`, {
                    method: 'POST',
                    data: { id: this.$route.params.roleId },
                })

                if (res.status === 'SUCCESS') {
                    this.$router.push('/settings/users/roles')
                    return
                }
                else this.$store.commit("openDialog", {
                    title: this.$t("something-went-wrong"),
                    content: this.$t('role-delete-failed'),
                    confirmCallBack: function () {}
                })
            } catch (err) {
                this.$log.error.call(this, err)
            }
        },
        openDeleteDialog() {
            this.$store.commit("openDialog", {
                title: this.$t("delete-role-question"),
                content: this.$t('action-cannot-be-undone'),
                confirmCallBack: this.deleteRole,
                cancelBtn: true,
            })
        },
        closeModal() {
            this.$emit('close')
        }
    },
    components: { PrivilegesEdit }
}
</script>
